import { createFileRoute, Outlet, redirect, useParams } from "@tanstack/react-router";
import { AppDmProvider } from "../components/legacy/app-state.tsx";
import { Sidebar } from "../components/legacy/Sidebar.tsx";
import { type AppConfig, api } from "../lib/api.ts";
import { isStaffRole } from "../lib/legacy.ts";
import { useAppConfig } from "./__root.tsx";

export const Route = createFileRoute("/app/$customerId")({
  component: AppLayout,
  beforeLoad: async ({ context, params }) => {
    const config = await context.queryClient.ensureQueryData({
      queryKey: ["config"],
      queryFn: () => api.get<AppConfig>("/config"),
    });
    if (!config.user) throw redirect({ to: "/sign-in" });
    // A customer may only open their own workspace; staff may open anyone's.
    if (!isStaffRole(config.user.role) && params.customerId !== config.user.id) {
      throw redirect({
        to: "/app/$customerId/mycampaigns",
        params: { customerId: config.user.id },
      });
    }
  },
});

function AppLayout() {
  const { customerId } = Route.useParams();
  const { campaignId } = useParams({ strict: false }) as { campaignId?: string };
  const { data } = useAppConfig();
  if (!data?.user) return null;
  return (
    <AppDmProvider user={data.user} customerId={customerId} campaignId={campaignId ?? null}>
      <Workspace />
    </AppDmProvider>
  );
}

function Workspace() {
  return (
    <div id="mail-product" className="flex min-h-[calc(100dvh-var(--header-h))] bg-gray-50">
      <Sidebar />
      {/* min-w-0 lets tables and the map shrink instead of forcing a page scrollbar. */}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col px-4 py-6 sm:px-6 lg:px-8">
        <Outlet />
      </div>
    </div>
  );
}
